import React from 'react';
import { Drawer } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';

interface DrawerWrapperProps extends DrawerProps {
  children: React.ReactNode;
}
const DrawerWrapper = (props: DrawerWrapperProps) => {
  return <Drawer getContainer={() => window.document.getElementById('root') || window.document.body} {...props} />;
};
export default DrawerWrapper;
